export function getIntermediateValues(startValue: number, endValue: number, step: number) {
  const values: number[] = [];

  let value = startValue < 0 ? 0 : startValue;

  while (value <= endValue) {
    values.push(value);

    value += step;
  }

  return values;
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/get-intermediate-values.ts